import * as React from "react";
import SaveDialogLayout from "components/DialogLayout/SaveDialogLayout";
import {DataBaseComponent, DataBaseComponentState} from "components/DataBaseComponent";
import repository from "client/repository";
import {Text} from "components/form";

interface Props {
    version: string;
    notes?: string;
    onChange: () => void;
}

interface State extends DataBaseComponentState {
    notes: string;
}

class EditHostedScriptsVersionNotesDialog extends DataBaseComponent<Props, State> {
    constructor(props: Props) {
        super(props);

        this.state = {
            notes: props.notes ?? ""
        };
    }

    render() {
        return <SaveDialogLayout title={`Notes for ${this.props.version}`}
                                 onSaveClick={() => this.save()}
                                 errors={this.state.errors}
                                 busy={this.state.busy}>
            <Text label="Notes"
                  value={this.state.notes}
                  multiLine={true}
                  rows={4}
                  hintText="Markdown, so a ticket can be linked: [CLOUDPT-11217](https://linear.app/...)"
                  onChange={notes => this.setState({notes})}
            />
        </SaveDialogLayout>;
    }

    private async save(): Promise<boolean> {
        return this.doBusyTask(async () => {
            await repository.HostedScripts.updateVersionNotes(this.props.version, {Notes: this.state.notes});
            this.props.onChange();
        });
    }
}

export default EditHostedScriptsVersionNotesDialog;
